import React from "react";
import { useInput, useTranslate } from "react-admin";

import { ThirdPartyAppStatus, ThirdPartyAppStatusName } from "entities/ThirdPartyAppStatus";
import {
	FilterToggleButtonGroup,
	StyledToggleButton,
} from "../../../components/filters/FilterToggleInput";


const statuses = [
	ThirdPartyAppStatus.review,
	ThirdPartyAppStatus.published,
	ThirdPartyAppStatus.rejected,
];

export const ThirdPartyAppStatusFilter = (props) => {
	const translate = useTranslate();
	const { input } = useInput(props);

	const handleChange = (e, newValue) => {
		input.onChange(newValue);
	};

	return (
		<FilterToggleButtonGroup value={input.value} onChange={handleChange} exclusive>
			{statuses.map((status) => (
				<StyledToggleButton value={status} key={status}>
					{translate(`osfc.enums.third_party_app.status.${ThirdPartyAppStatusName[status]}`)}
				</StyledToggleButton>
			))}
		</FilterToggleButtonGroup>
	);
};
